export const finalization = new FinalizationRegistry(function cleanupCallback(
  heldValue: any
) {
  switch ('function') {
    case typeof heldValue: {
      heldValue()

      break
    }
    case typeof heldValue?.destroy: {
      heldValue.destroy()

      break
    }
    case typeof heldValue?.dispose: {
      heldValue.dispose()

      break
    }
    default: {
      if (Array.isArray(heldValue)) {
        heldValue.forEach(cleanupCallback)
      } else if (heldValue instanceof WeakRef) {
        cleanupCallback(heldValue.deref())
      }
    }
  }
})
